module.exports = __webpack_public_path__ + "static/media/StartResignation.f95b380e.svg";